export default __webpack_public_path__ + "static/media/gallery_04.53221942.jpg";